exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".infographic{margin-bottom:15px}.infographic .infographic-img-container .infographic-img{max-width:100%}.infographic .infographic-content{padding:15px}.infographic .infographic-label{background-color:#4ea3d8;padding:5px;display:block;color:#fff}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/Infographic/style.scss
// module id = 1314
// module chunks = 0